import { useState, useEffect } from 'react';
// Remove direct Firebase imports
// import { db } from '../firebase/firebase';
// import { collection, getDocs } from "firebase/firestore";
// Add UserService import
import { services } from '../Services/AdminService';

export const useUserCount = () => {
  // Get UserService instance
  const userService = services.users;
  const [userCount, setUserCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUserCount = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await userService.getUserCount();
      if (result.success) {
        setUserCount(result.data);
      } else {
        setError(result.message || 'Failed to fetch user count');
      }
    } catch (err) {
      console.error("Error fetching user count: ", err);
      setError("Failed to load user count.");
    } finally {
      setLoading(false);
    }
  };

  const refreshUserCount = () => {
    fetchUserCount();
  };

  useEffect(() => {
    fetchUserCount();
  }, []);

  return {
    userCount,
    loading,
    error,
    refreshUserCount
  };
}; 